<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>ข้อมูลพื้นฐาน</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลผู้ถือหุ้น</span>
          <span class="separator"></span>
          <span><b>ข้อมูลพื้นฐาน</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>
      <table class="table mb-5 mt-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col">
              <h4 class="mt-1">ข้อมูลทั่วไปของบริษัท</h4>
            </th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row"><b>ชื่อบริษัท</b></th>
            <td>บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน) (“ บริษัทฯ ”)</td>
          </tr>
          <tr>
            <th scope="row"><b>ชื่อย่อหลักทรัพย์</b></th>
            <td>ORI</td>
          </tr>
          <tr>
            <th scope="row"><b>ประเภทธุรกิจ</b></th>
            <td>ประกอบธุรกิจพัฒนาอสังหาริมทรัพย์</td>
          </tr>
          <tr>
            <th scope="row"><b>เลขทะเบียนบริษัท</b></th>
            <td>0107557000381</td>
          </tr>
          <tr>
            <th scope="row"><b>จำนวนหุ้นจดทะเบียน</b></th>
            <td>หุ้นสามัญ 2,452,862,453 หุ้น ณ วันที่ 31 ธันวาคม 2563</td>
          </tr>
          <tr>
            <th scope="row"><b>ทุนจดทะเบียน</b></th>
            <td>1,545,776,222.50 บาท ณ วันที่ 31 ธันวาคม 2563</td>
          </tr>
          <tr>
            <th scope="row"><b>ทุนจดทะเบียนเรียกชำระแล้ว</b></th>
            <td>1,226,431,226.50</td>
          </tr>
          <tr>
            <th scope="row"><b>มูลค่าหุ้น</b></th>
            <td>หุ้นละ 0.50 บาท</td>
          </tr>
          <tr>
            <th scope="row"><b>ที่ตั้งสำนักงานใหญ่</b></th>
            <td>เลขที่ 496 หมู่ที่ 9 ตำบลสำโรงเหนือ อำเภอเมืองสมุทรปราการ จังหวัดสมุทรปราการ 10270</td>
          </tr>
          <tr>
            <th scope="row"><b>โทรศัพท์</b></th>
            <td>02 030 0000</td>
          </tr>
          <tr>
            <th scope="row"><b>โทรสาร</b></th>
            <td>02 398 8066</td>
          </tr>
          <tr>
            <th scope="row"><b>ที่อยู่สำหรับติดต่อ</b></th>
            <td>ชั้น 20 อาคารภิรัชทาวเวอร์ แอท ไบเทค เลขที่ 4345 ถนนสุขุมวิท แขวงบางนา เขตบางนา กรุงเทพมหานคร 10260</td>
          </tr>
          <tr>
            <th scope="row"><b>เว็บไซต์บริษัท</b></th>
            <td>https://origin.co.th/</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
  name: 'Info',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
      financialData: null,
    };
  },
  methods: {
    async init() {
      let response = await store.dispatch(GET_FINANCIAL_DATA);
      if (response) {
        this.financialData = response; // Assign fetched data to local state
      } else {
        console.error('Failed to fetch financial data');
      }
    },
  },

};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}
</style>
